import Tooltip from 'components/Tooltip';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SLabel } from './styles';
import PremiumIcon from 'components/PremiumIcon';

interface LabelProps {
    name?: string;
    text: string;
    required?: boolean;
    helper?: string;
    isPremiumFeature?: boolean;
}

const Label: FC<LabelProps> = ({ name, text, required, helper, isPremiumFeature = false }) => {
    const { t } = useTranslation();

    return (
        <SLabel htmlFor={name}>
            {`${t(text)} ${required ? '*' : ''}`}
            {helper && <Tooltip label={helper} />}
            {isPremiumFeature && (
                <PremiumIcon />
            )}
        </SLabel>
    );
};

export default Label;
